import React from "react";
import PdfViewer from "../../PdfViewer";

const PythonTema8 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema8_Visualizacion_Datos.pdf`;
  /*const pdfUrl = "/pdf/Tema8_Visualizacion_Datos.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Tema 8: Visualización de Datos</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PythonTema8;
